let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9tG6Z")).then(() => parcelRequire('Li5l0'));